function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.415 18a8.587 8.587 0 10-8.587-8.587",
  stroke: "currentColor",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.743 10.014l-.918 1.06-.917-1.06h1.835z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 1.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.414 4.69v4.723l2.576.859",
  stroke: "currentColor",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgPending = function SvgPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyMSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjQxNDcgMTguMDAwNUMxNi4xNTcyIDE4LjAwMDUgMjAuMDAxOCAxNC4xNTU5IDIwLjAwMTggOS40MTMzM0MyMC4wMDE4IDQuNjcwNzcgMTYuMTU3MiAwLjgyNjE3MiAxMS40MTQ3IDAuODI2MTcyQzYuNjcyMiAwLjgyNjE3MiAyLjgyNzY0IDQuNjcwNzcgMi44Mjc2NCA5LjQxMzMzIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMy43NDI5NSAxMC4wMTM5TDIuODI1MjQgMTEuMDczN0wxLjkwNzU0IDEwLjAxMzlMMy43NDI5NSAxMC4wMTM5WiIgZmlsbD0iY3VycmVudENvbG9yIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjIiLz4KPHBhdGggZD0iTTExLjQxMzYgNC42OTA0M1Y5LjQxMzMzTDEzLjk4OTcgMTAuMjcyIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgPending as ReactComponent };